<template>
  <div>
    <!-- 下级机构结算 用户类型1、运营 2、商户 3、下级机构 4、业务员-->
    <subordinate v-if="userInfo.userType == 3"></subordinate>
    <org v-else></org>
  </div>
</template>

<script>
import org from './org';
import subordinate from './subordinate';
export default {
  components: {
    org,
    subordinate
  },
  data() {
    return {
      userInfo: JSON.parse(window.localStorage.getItem('userInfo'))
    };
  }
};
</script>
